import { render, staticRenderFns } from "./WorkOrderUpgradeDialog.vue?vue&type=template&id=9f74a522&scoped=true"
import script from "./WorkOrderUpgradeDialog.vue?vue&type=script&lang=js"
export * from "./WorkOrderUpgradeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f74a522",
  null
  
)

export default component.exports